const SourceType = {
  NC: 'new-colors',
  SYL: 'shop-your-looks',
  HOMEPAGE: 'homepage',
  SHOPPING_BAG: 'shopping-bag',
  SI: 'save-for-later',
  CATEGORIES: 'categories',
  UNGATED: 'ungated_shop',
  SEARCH_RESULTS: 'search_results',
  STYLE_CARD: 'style-card',
};

export default SourceType;
